import { History } from 'history';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import en from '../../../lang/en-us';
import { LoadDots } from '../../../lib/Button';
import { CustomToolTip } from '../../../lib/DataTable';
import { NoteModals } from '../../../lib/NoteModals';
import SearchInput from '../../../lib/SearchInput';
import { RootStateType } from '../../../redux-store/reducers';
import { PORTFOLIO_RESPONSE } from '../../../redux-store/types/portfolio';
import {
    FAQ_URL,
    isMobileDevice,
    NEW_PURCHASE,
    THRESH_HOLD_MKT_VALUE,
    TRANSFER_OF_UNITS,
} from '../../../utils/constants';
import HomePageCard from '../../home/card';
import { isMobile } from '../../quick-links/faq';
import RouteWrapper from '../routes';
import { getChangeEmailFlow } from './ChangeEmail/flow';
import { getChangeMobileFlow } from './ChangeMobile/flow';
import { NctRoutes } from './routeConfig';
const { dashboard, nctLinks, common } = en;

type NCT_ACTIONS = {
    actionName: string;
    image1: string;
    image2: string;
    onClickAction: Function;
    spanText?: string;
    comingSoon?: boolean;
    loading?: boolean;
    disabled?: boolean;
    toolTipText?: string;
};

type FaqLinkProps = {
    history?: History;
    section: string;
};

type ActionHeaderProps = {
    header: string;
    subHeader?: string;
};

export const FaqLink = ({ section, history }: FaqLinkProps) => {
    const _history = useHistory();
    return (
        <h5
            className="refer-faq-link"
            style={
                section === NEW_PURCHASE ? { marginTop: 10, marginBottom: 5 } : { marginTop: 10 }
            }
        >
            {common.referFAQ}
            <a
                className="link-active"
                onClick={() => {
                    if (isMobileDevice() || isMobile(window.navigator.userAgent)) {
                        _history.push(FAQ_URL, { section });
                    } else {
                        window.open(
                            `${window.location.origin}/links/faq?section=${section}`,
                            '_blank',
                        );
                        // obj.location. = section;
                    }
                }}
            >
                {common.FAQ}
            </a>
        </h5>
    );
};

export const ActionHeader = ({ header = '', subHeader }: ActionHeaderProps) => {
    const history = useHistory();
    return (
        <h2 className="heading">
            <a onClick={() => history.goBack()}>
                <img src="/images/left-arrow-black.svg" alt="icon" />
            </a>
            {header}
            {subHeader && <span>{subHeader}</span>}
        </h2>
    );
};

export function NctActions(params: any) {
    const reduxState = useSelector((state: RootStateType) => ({
        ...state.authReducer,
        ...state.portfolio,
    }));
    const { pekrn, portfolios, userRegisteredWith } = reduxState;
    const { portfolio } = portfolios || {};
    const { currentMktValue: dematMktValue = 0 }: PORTFOLIO_RESPONSE = portfolio?.demat || {};
    const { currentMktValue: nonDematMktValue = 0 }: PORTFOLIO_RESPONSE =
        portfolio?.non_demat || {};
    const totalMktValue: number = Number(dematMktValue) + Number(nonDematMktValue);
    const actions: NCT_ACTIONS[] = [
        {
            actionName: nctLinks.dividend,
            image1: '/images/change-dividend.svg',
            image2: '/images/change-dividend-white.svg',
            onClickAction: () => params.history.push('/portal/nct/change-dividend'),
        },
        {
            actionName: nctLinks.changeemail,
            image1: '/images/change-email.svg',
            image2: '/images/change-email-white.svg',
            onClickAction: () => {
                const [initRoute] = getChangeEmailFlow(userRegisteredWith);
                params.history.push(initRoute);
            },
        },
        {
            actionName: nctLinks.changecontact,
            image1: '/images/change-contact.svg',
            image2: '/images/change-contact-white.svg',
            onClickAction: () => {
                const [initRoute] = getChangeMobileFlow(userRegisteredWith);
                params.history.push(initRoute);
            },
        },
        {
            actionName: nctLinks.consolidation,
            image1: '/images/consolidation.svg',
            image2: '/images/consolidation-white.svg',
            onClickAction: () => params.history.push('/portal/nct/consolidation-folios'),
        },
        {
            actionName: nctLinks.datacapture,
            image1: '/images/data-capture.svg',
            image2: '/images/data-capture-white.svg',
            onClickAction: () => params.history.push('/portal/nct/corrections-folios'),
        },
        {
            actionName: nctLinks.changebank,
            image1: '/images/change-bank.svg',
            image2: '/images/change-bank-white.svg',
            onClickAction: () => params.history.push('/portal/nct/change-bank'),
            loading: !portfolios,
            disabled: totalMktValue > THRESH_HOLD_MKT_VALUE,
            toolTipText:
                totalMktValue > THRESH_HOLD_MKT_VALUE
                    ? common.nctDisableAboveThreshHold
                    : !portfolio
                    ? 'Loading...'
                    : '',
        },
        {
            actionName: nctLinks.multiplebank,
            image1: '/images/multiple-bank.svg',
            image2: '/images/multiple-bank-white.svg',
            onClickAction: () => params.history.push('/portal/nct/bank-mandate'),
            loading: !portfolios,
            disabled: totalMktValue > THRESH_HOLD_MKT_VALUE,
            toolTipText:
                totalMktValue > THRESH_HOLD_MKT_VALUE
                    ? common.nctDisableAboveThreshHold
                    : !portfolio
                    ? 'Loading...'
                    : '',
        },
        {
            actionName: nctLinks.changenominee,
            image1: '/images/change-nominee.svg',
            image2: '/images/change-nominee-white.svg',
            onClickAction: () => params.history.push('/portal/nct/update-nominee'),
        },
        {
            actionName: nctLinks.changebanktype,
            image1: '/images/change-banktype.svg',
            image2: '/images/change-banktype-white.svg',
            onClickAction: () => params.history.push('/portal/nct/update-ifsc'),
        },
        {
            actionName: nctLinks.changeinvestor,
            image1: '/images/change-investor.svg',
            image2: '/images/change-investor-white.svg',
            onClickAction: () => params.history.push('/portal/nct/change-tax'),
            spanText: nctLinks.changeinvestorinfo,
            // comingSoon: true,
        },
        {
            actionName: nctLinks.transmission,
            image1: '/images/transmission.svg',
            image2: '/images/transmission-white.svg',
            onClickAction: () => params.history.push('/portal/nct/transmission-pan'),
            // comingSoon: true,
        },
        {
            actionName: nctLinks.fatca,
            image1: '/images/fatca-nct.svg',
            image2: '/images/fatca-nct-white.svg',
            onClickAction: () => params.history.push('/portal/nct/fatca-declaration'),
        },
        {
            actionName: nctLinks.minor,
            image1: '/images/minor-nct.svg',
            image2: '/images/minor-nct-white.svg',
            onClickAction: () => params.history.push('/portal/nct/minor-status'),
        },
        {
            actionName: nctLinks.transferOfUnits,
            image1: '/images/transfer.svg',
            image2: '/images/transfer-white.svg',
            onClickAction: () => params.history.push(TRANSFER_OF_UNITS),
        },
        {
            actionName: nctLinks.lockUnlockFolios || 'Lock/Unlock Folios',
            image1: '/images/lockDarkNew.svg',
            image2: '/images/lockWhite.svg',
            onClickAction: () => params.history.push('/portal/nct/lock-unlock-folios'),
        },
        // {
        //     actionName: nctLinks.form15,
        //     image1: '/images/form15-nct.svg',
        //     image2: '/images/form15-nct-white.svg',
        //     onClickAction: !pekrn
        //         ? () => setModal(true)
        //         : () => {
        //             alert(common.notAlligibleForPekrn);
        //             return;
        //         },
        // },
    ];
    const [showModal, setModal] = useState<boolean>(false);
    const [searchString, setSearchString] = useState<string>('');

    const _handleNCTSearch = () => {
        if (!!searchString) {
            return actions.filter((_ele: NCT_ACTIONS) =>
                _ele.actionName.toLowerCase().includes(searchString.toLowerCase()),
            );
        }
        return actions;
    };
    return (
        <div className="curved-bg">
            <div className="make-nct">
                <HomePageCard className="db-banner">
                    <>
                        <img
                            className="db-banner-character"
                            src="/images/nct-character.png"
                            alt="icon"
                        />
                        <h3>
                            {dashboard.dbNct.heading}
                            <b>{dashboard.dbNct.headingBold}</b>
                        </h3>
                    </>
                </HomePageCard>
                <div className="make-nct-bottom">
                    <div className="db-nct-search">
                        <SearchInput
                            id="make-nct-search"
                            darkmode={true}
                            value={searchString}
                            onChange={({ target: { value } }: any) => setSearchString(value)}
                        />
                    </div>
                    <div className="box-cards-links db-nct-list">
                        {_handleNCTSearch().map((_ele: NCT_ACTIONS, index: number) => (
                            <div className="box-cards-links-info" key={index}>
                                <CustomToolTip arrow title={_ele.toolTipText || ''}>
                                    <a
                                        onClick={() =>
                                            !_ele.comingSoon &&
                                            !_ele.disabled &&
                                            _ele.onClickAction()
                                        }
                                    >
                                        <div className="nct-list-images">
                                            <img
                                                className="nct-box-inactive"
                                                src={_ele.image1}
                                                alt="icon"
                                            />
                                            <img
                                                className="nct-box-active"
                                                src={_ele.image2}
                                                alt="icon"
                                            />
                                        </div>
                                        {_ele.comingSoon && (
                                            <img
                                                className="nct-coming-soon"
                                                src="/images/coming-soon.svg"
                                                alt="icon"
                                            />
                                        )}
                                        <h4>
                                            {_ele.actionName}
                                            {_ele.spanText && <span>{_ele.spanText}</span>}
                                        </h4>
                                        {_ele.loading && (
                                            <div className="nct-list-loader">
                                                {_ele.loading && <LoadDots />}
                                            </div>
                                        )}
                                    </a>
                                </CustomToolTip>
                            </div>
                        ))}
                        {_handleNCTSearch().length === 0 && (
                            <p className="no-nct">{nctLinks.notMatched}</p>
                        )}
                    </div>
                </div>
                <NoteModals
                    showModal={showModal}
                    extraClass="form15-main-modal"
                    heading={dashboard.UpdateForm15.pleaseNote}
                    info={dashboard.UpdateForm15.modalInfo}
                    proceedBtn={dashboard.UpdateForm15.proceedBtn}
                    onProceed={() => params.history.push('/portal/nct/update-form15')}
                />
            </div>
        </div>
    );
}

export default (props: any) => (
    <RouteWrapper
        routes={NctRoutes}
        matchPath={props.match.path}
        initPath={'/actions'}
        {...props}
    />
);
